module.exports = __webpack_public_path__ + "static/media/OWL_Logos_FInal-03-Light.b93de0b6.png";